import { render, staticRenderFns } from "./ProductPromo.vue?vue&type=template&id=68c2648a"
import script from "./ProductPromo.vue?vue&type=script&lang=js"
export * from "./ProductPromo.vue?vue&type=script&lang=js"
import style0 from "./ProductPromo.vue?vue&type=style&index=0&id=68c2648a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports